import PropTypes from 'prop-types';
import React from 'react';
import { EditorBlock } from 'draft-js';
import styles from './text-editor-code-block.scss';

const TextEditorCodeBlock = ({ blockProps: { backgroundColor }, ...rest }) =>
  <pre className={styles.container}>
    <div className={styles.code} style={{ backgroundColor }}>
      <EditorBlock {...rest}/>
    </div>
  </pre>;

TextEditorCodeBlock.propTypes = {
  blockProps: PropTypes.object,
};

export default TextEditorCodeBlock;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-code-block.js